import React, { useState } from "react";
import Training_observation_plan_Top from "../../blog/Training_observation_plan_Top";
import PeerEvaluationForm from "../../blog/Evalution";
import PreTrainingFeedback from "../../blog/Pre-Training-Feedback";
import Post_Feedback from "../../store/Post_Feedback";
import FoodFeedbackForm from "../../blog/FoodFeedback/FoodFeedbackForm";
import KVSRegistrationForm from "../../blog/Post-Training-Feedback";
import { useSelector } from "react-redux";

/* ---------------------------------------------------------------------
    Sample data for each feedback tab.
    Replace with real values once the feedback-form API endpoint is
    wired up (e.g. GET /feedback/pre-training, GET /feedback/post-training).
  --------------------------------------------------------------------- */

const feedbackTabs = [
  {
    id: "pre",
    label: "Pre-training Feedback",
  },
  {
    id: "food",
    label: "Food & Room Feedback",
  },
  {
    id: "post",
    label: "Post Training Feedback",
  },
];

export default function Top() {
  const [activeTab, setActiveTab] = useState(feedbackTabs[0].id);
  const activeTabData =
    feedbackTabs.find((tab) => tab.id === activeTab) || feedbackTabs[0];

  const { is_post_feedback_form_disabled } = useSelector(
    (state) => state.setting.setting
  );

  return (
    <div className="fb-wrap">
      <style>{`
        .fb-wrap {
          font-family: inherit;
        }

        .fb-card {
          background: #ffffff;
          border: none;
          border-radius: 1rem;
          box-shadow: 0 2px 12px rgba(17, 24, 39, 0.06);
          overflow: hidden;
          max-height:450em
        }

        .fb-header {
          padding: 1.5rem 1.5rem 0;
        }

        .fb-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 1rem;
        }

        /* ---- Underline tab nav ---- */
        .fb-tab-nav {
          display: flex;
          gap: 2rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .fb-tab-btn {
          background: none;
          border: none;
          padding: 0 0 0.85rem;
          font-size: 0.95rem;
          font-weight: 600;
          color: #94a3b8;
          cursor: pointer;
          position: relative;
          white-space: nowrap;
          transition: color 0.15s ease;
        }

        .fb-tab-btn:hover {
          color: #16a34a;
        }

        .fb-tab-btn--active {
          color: #1e293b;
          font-weight: 700;
        }

        .fb-tab-btn::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 3px;
          border-radius: 999px 999px 0 0;
          background: transparent;
          transition: background-color 0.15s ease;
        }

        .fb-tab-btn--active::after {
          background: #16a34a;
        }

        /* ---- Feedback item rows ---- */
        .fb-body {
          padding: 1.25rem 1.5rem 1.5rem;
        }

        .fb-item-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          padding: 0.9rem 0.25rem;
          border-bottom: 1px dashed #eef0f3;
        }

        .fb-item-row:last-child {
          border-bottom: none;
        }

        .fb-item-title {
          font-size: 0.92rem;
          font-weight: 700;
          color: #1e293b;
        }

        .fb-item-sub {
          font-size: 0.78rem;
          color: #64748b;
          margin-top: 2px;
        }

        .fb-item-right {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-shrink: 0;
        }

        .fb-status {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.03em;
          text-transform: uppercase;
          border-radius: 999px;
          padding: 3px 10px;
          white-space: nowrap;
        }

        .fb-status--submitted {
          background: #e6f4ea;
          color: #15803d;
        }

        .fb-status--pending {
          background: #f1f5f9;
          color: #64748b;
        }

        .fb-action-btn {
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-size: 0.82rem;
          font-weight: 700;
          color: #ffffff;
          background: #16a34a;
          cursor: pointer;
          white-space: nowrap;
          transition: box-shadow 0.15s ease, opacity 0.15s ease;
        }

        .fb-action-btn:hover {
          box-shadow: 0 6px 16px rgba(22, 163, 74, 0.3);
        }

        .fb-action-btn--outline {
          background: #ffffff;
          color: #16a34a;
          border: 1.5px solid #86efac;
        }

        /* ---------------- Responsive (tabs) ---------------- */

        @media (max-width: 768px) {
          .fb-header {
            padding: 1.1rem 1rem 0;
          }

          .fb-title {
            font-size: 1rem;
            margin-bottom: 0.75rem;
          }

          /* Tabs become a horizontally scrollable, swipeable strip
             instead of wrapping or squeezing — long labels like
             "Pre-training Feedback" stay on one line and readable. */
          .fb-tab-nav {
            gap: 1.25rem;
            overflow-x: auto;
            overflow-y: hidden;
            flex-wrap: nowrap;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 2px;
            margin: 0 -1rem;
            padding-left: 1rem;
            padding-right: 1rem;
          }

          .fb-tab-nav::-webkit-scrollbar {
            display: none;
          }

          .fb-tab-btn {
            flex: 0 0 auto;
            font-size: 0.86rem;
            padding-bottom: 0.7rem;
          }
        }

        @media (max-width: 576px) {
          .fb-header {
            padding: 1rem 0.85rem 0;
          }

          .fb-tab-nav {
            gap: 1rem;
            margin: 0 -0.85rem;
            padding-left: 0.85rem;
            padding-right: 0.85rem;
          }

          .fb-tab-btn {
            font-size: 0.8rem;
          }

          .fb-item-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.6rem;
          }
          .fb-item-right {
            width: 100%;
            justify-content: space-between;
          }
        }

        @media (max-width: 400px) {
          .fb-tab-btn {
            font-size: 0.75rem;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .fb-tab-btn,
          .fb-tab-btn::after,
          .fb-action-btn {
            transition: none;
          }
        }
      `}</style>

      <div className="fb-card">
        <div className="fb-header">
          <h5 className="fb-title">Feedback</h5>
          <div className="fb-tab-nav">
            {feedbackTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`fb-tab-btn ${activeTab === tab.id ? "fb-tab-btn--active" : ""
                  }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div>
            {activeTab == "pre" ? (
              <PreTrainingFeedback />
            ) : activeTab == "post" ? (
              Number(is_post_feedback_form_disabled) === 1 ? (
                <div className="text-center p-4">
                  <p className="text-muted mb-0">
                    Post Training Feedback is currently disabled.
                  </p>
                </div>
              ) : (
                <KVSRegistrationForm />
              )
            ) : (
              <FoodFeedbackForm />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
